/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './checkbox.css'
import lightThemeUncheckedIcon from '../../../images/checkbox-unchecked.svg'
import lightThemeCheckedIcon from '../../../images/checkbox-checked.svg'
import darkThemeUncheckedIcon from '../../../images/neon/checkbox-unchecked.svg'
import darkThemeCheckedIcon from '../../../images/neon/checkbox-checked.svg'

function Checkbox({
  isChecked,
  id,
  label,
  labelClassName,
  onChange,
  value,
  className,
  wrapperClassName,
  darkTheme
}) {
  const checkedIcon = darkTheme ? darkThemeCheckedIcon : lightThemeCheckedIcon
  const uncheckedIcon = darkTheme ? darkThemeUncheckedIcon : lightThemeUncheckedIcon
  const icon = isChecked ? checkedIcon : uncheckedIcon

  const onCLick = evt => {
    evt.stopPropagation()
    evt.preventDefault()
    onChange(evt, value, !isChecked)
  }
  const wrapperClass = className || styles.checkboxWrapper

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      data-lbx-e2e="checkbox"
      onClick={onCLick}
      className={classNames(
        wrapperClassName,
        wrapperClass,
        {
          [styles.darkTheme]: darkTheme
        }
      )}
    >
      <img // eslint-disable-line jsx-a11y/no-static-element-interactions
        onKeyPress={onCLick}
        tabIndex={0}
        src={icon}
        alt={`${isChecked}`}
      />
      {label && (
        <label className={classNames(labelClassName)} htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  )
}

Checkbox.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  labelClassName: PropTypes.string,
  className: PropTypes.string, // for outer class (can override default)
  wrapperClassName: PropTypes.string, // to extend or override wrapper styling
  darkTheme: PropTypes.bool
}

Checkbox.defaultProps = {
  id: '',
  label: '',
  onChange: (evt, value, isChecked) => {},
  value: '',
  labelClassName: '',
  className: '',
  wrapperClassName: '',
  darkTheme: false
}

export default Checkbox
